import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.runSliders();
      this.scrollToAnchor();
      this.playVideo();
      this.videoModal();
      this.sidebarWidget();
    },

    headerFunctions: function () {
      $(".toggle-nav").click(function (e) {
        $(".navbar .main-menu-container").fadeToggle();
        $(".icon-bar").toggleClass("toggled");
        e.preventDefault();
      });
    },

    runSliders: function () {
      $(".hero-slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
        infinite: true,
        autoplay: true,
        fade: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
            },
          },
        ],
      });

      $("#hero .backgrounds, #features .backgrounds").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider",
      });

      $(".slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        asNavFor: "#hero .backgrounds, #features .backgrounds",
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              arrows: false,
            },
          },
        ],
      });

      $(".service-slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1050,
            settings: {
              arrows: false,
            },
          },
        ],
      });

      if ($(window).width() > 922) {
        $(".news-slider").slick({
          prevArrow: '<span class="prev"></span>',
          nextArrow: '<span class="next"></span>',
          infinite: false,
          variableWidth: true,
        });
      }

      if ($(window).width() < 640) {
        $("#offices .boxes").slick({
          arrows: false,
          variableWidth: true,
          slidesToShow: 1,
          centerMode: true,
          autoplay: true,
        });
      }

      $(".tenants-slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
      });

      $(".tenants-nav").slick({
        focusOnSelect: true,
        variableWidth: true,
        arrows: false,
        infinite: false,
      });

      $(".slide-gallery").slick({
        infinite: false,
        arrows: false,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $(".gallery").slick({
        arrows: false,
        dots: true,
        fade: true,
      });

      $(".services_slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              infinite: true,
            },
          },
        ],
      });

      $(".related-slider").slick({
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
        variableWidth: true,
      });

      $(".tour-slider").slick({
        arrows: false,
        dots: true,
        fade: true,
      });

      $(".slick-slider").each(function () {
        $(this).find(".slick-arrow").wrapAll('<div class="slider-nav"></div>');
      });
    },

    scrollToAnchor: function () {
      $("a.arrow-down").on("click", function (e) {
        e.preventDefault();
        var href = $(this).attr("href");
        $("html, body").animate(
          {
            scrollTop: $(href).offset().top - 50,
          },
          1500
        );
      });
    },

    playVideo: function () {
      $(".single-post #post_content .post-video img.play").click(function () {
        $(this).fadeOut();
        let video = $(this).parent().find("video");
        video.css("opacity", "1");
        video[0].play();
        video.attr("controls", "");
      });
    },

    videoModal: function () {
      $("#virtual_tour a.movie").click(function (e) {
        e.preventDefault();
        $(this).find(".movie-modal").modal({
          opacity: 80,
          overlayClose: true,
        });
        var video = $("#simplemodal-container video");
        video[0].play();
      });
    },

    sidebarWidget: function () {
      $(".sidebar-widget .trigger").click(function () {
        $(".sidebar-widget").removeClass('opened');
        $(".sidebar-widget").addClass("opened");
      });

      $('.sidebar-widget .widget .close').click(function () {
        $(".sidebar-widget .trigger").addClass('opened');
        $(".sidebar-widget").removeClass("opened");
      });
    },
  };
})(jQuery);
